import { TextField } from '@/ui/form/controls/TextField'

import * as React from 'react'
import ErrorLabel from '../../shared/ErrorLabel'
import { ContractDetailsModel } from '@/modules/drivers/types/contracts'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

interface Props {
  label: string
  labelSecondary: string
  data: ContractDetailsModel | null
  setData: React.Dispatch<React.SetStateAction<ContractDetailsModel | null>>
}

const FullTimeField = ({ data, setData, label, labelSecondary }: Props) => {
  const { t } = useLocalize()
  const denominator = data?.workTime?.denominatorPart ?? null
  const numerator = data?.workTime?.numeratorPart ?? null

  const isInvalid =
    numerator !== null &&
    denominator !== null &&
    (numerator !== 1 || denominator < 1 || numerator > denominator)
  return (
    <div className="tw-flex tw-items-stretch tw-gap-4">
      <div className="tw-flex tw-flex-col">
        <label className="tw-text-conntent-base tw-text-sm tw-font-medium">
          {label}
        </label>

        <div
          className={`tw-flex tw-max-w-[120px] tw-items-center tw-justify-between tw-rounded-md tw-border tw-border-gray-300 ${isInvalid ? 'tw-border-error tw-text-error' : ''} `}
        >
          <input
            type="text"
            pattern="\d*"
            className="tw-focus:outline-none tw-mx-3 tw-my-[4.75px] tw-max-w-8 tw-text-center"
            maxLength={3}
            value={numerator}
            placeholder="1"
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\D/g, '')
              setData({
                ...data,
                workTime: {
                  ...data?.workTime,
                  numeratorPart: Number(e.target.value || 0),
                },
              })
            }}
          />

          <span className="tw-text-black">/</span>

          <input
            type="text"
            pattern="\d*"
            className="tw-focus:outline-none tw-mx-3 tw-my-[4.75px] tw-max-w-8 tw-text-center"
            maxLength={3}
            value={denominator}
            placeholder="1"
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\D/g, '')
              setData({
                ...data,
                workTime: {
                  ...data?.workTime,
                  denominatorPart: Number(e.target.value || 0),
                },
              })
            }}
          />
        </div>

        {isInvalid && <ErrorLabel error={t('contract.invalid-value')} />}
      </div>
      {denominator > numerator && (
        <div className="tw-flex tw-flex-1 tw-flex-col tw-items-start">
          <label className="tw-text-conntent-base tw-text-sm tw-font-medium">
            {labelSecondary}
          </label>
          <TextField
            fullWidth
            type="number"
            value={data?.weekWorkTimeHours?.toString() ?? ''}
            onChange={(e) =>
              setData({ ...data, weekWorkTimeHours: Number(e.target.value) })
            }
            onBlur={() => {
              if (data?.weekWorkTimeHours > 39) {
                setData({ ...data, weekWorkTimeHours: 39 })
              }
            }}
          />
        </div>
      )}
    </div>
  )
}

export default FullTimeField
